export default "__VITE_ASSET__Cul32wn5__"